var path = 'entity/entity-subtype-select.tpl.html';
var html = "\n<md-input-container>\n    <label ng-if=\"showLabel\">{{ entitySubtypeTitle | translate }}</label>\n    <md-select name=\"subType\" ng-model=\"entitySubtype\" class=\"tb-entity-subtype-select\" aria-label=\"{{ entitySubtypeTitle | translate }}\">\n        <md-option ng-repeat=\"subType in entitySubtypes\" ng-value=\"subType\">\n            {{ subTypeName(subType) }}\n        </md-option>\n    </md-select>\n    <div ng-messages=\"theForm.subType.$error\">\n        <div ng-message=\"required\" translate>{{ entitySubtypeRequiredText }}</div>\n    </div>\n</md-input-container>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/entity/entity-subtype-select.tpl.html
// module id = 1472
// module chunks = 1